import { useEffect } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';

import { SiteFooter } from '@/components/site-footer';
import { SiteHeader } from '@/components/site-header';
import { DocumentMeta } from '@/components/document-meta';
import { DynamicText } from '@/components/dynamic-text';
import { DynamicTextProvider } from '@/lib/dynamic-text-context';
import { Button } from '@/components/ui/button';
import AboutPage from '@/pages/about';
import HomePage from '@/pages/home';
import PrivacyPage from '@/pages/privacy';
import ResetPage from '@/pages/reset';
import SupportPage from '@/pages/support';
import TermsPage from '@/pages/terms';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash]);
  return null;
}

function NotFoundPage() {
  return (
    <div className="container py-32 text-center">
      <p className="kicker">
        <DynamicText path="not_found.kicker">404</DynamicText>
      </p>
      <h1 className="mt-4 text-[clamp(2.2rem,6vw,3.5rem)]">
        <DynamicText path="not_found.title">This page came off the vine.</DynamicText>
      </h1>
      <p className="mx-auto mt-5 max-w-md text-muted-foreground">
        <DynamicText path="not_found.description">
          The page you were looking for is not here.
        </DynamicText>
      </p>
      <Button asChild className="mt-8">
        <Link to="/">Back to the home page</Link>
      </Button>
    </div>
  );
}

export default function App() {
  return (
    <DynamicTextProvider>
      <div className="grain flex min-h-dvh flex-col">
        <ScrollToTop />
        <DocumentMeta />
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
        >
          Skip to content
        </a>
        <SiteHeader />
        <main id="main" className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/reset" element={<ResetPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <SiteFooter />
      </div>
    </DynamicTextProvider>
  );
}
